<template>
  <div>
    <app-bar :showtab="false" back>
      <template v-slot:title>添加:{{ title }}</template>
      <template v-slot:fun-icons>
        <v-btn :loading="loading" @click="upload" dark text color="white"
          >提交</v-btn
        >
      </template>
    </app-bar>

    <submit-form ref="upload" :data="data" />
    <Vaptcha
      ref="captcha"
      v-model="vaptcha"
      scene="1"
      style="height: 46px"
      type="click"
    ></Vaptcha>
    <v-btn
      class="mt-4"
      block
      :loading="loading"
      @click="upload"
      color="link"
      dark
      >提交</v-btn
    >
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import list from "../../networker/list";
import SubmitForm from "../../components/content/SubmitForm/SubmitForm.vue";
import submit from "@/networker/submit";
export default {
  components: {
    AppBar,
    SubmitForm,
  },
  data() {
    return {
      title: "",
      data: {},
      captcha: {},
      vaptcha: "",
      loading: false,
    };
  },
  async activated() {
    this.title = "加载中";
    let res = await list.getRepInfo(this.$route.params.uuid);
    if (res.data.success) {
      this.title = res.data.data.name;
    }
  },
  methods: {
    async upload() {
      let bool = this.$refs.upload.validate();
      if (!bool) {
        this.$emit("snackbar", {
          text: "请先完成表单",
        });
        return;
      }

      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先完成验证",
        });
        return;
      }
      this.loading = true;
      this.data.captcha = this.captcha;
      this.data.black_id = this.$route.params.uuid;
      this.data.level = parseInt(this.data.level, 10);
      this.data.qq = parseInt(this.data.qq, 10);
      this.data.phone = parseInt(this.data.phone, 10) || 0;
      let res = await submit.submit(this.data);
      if (res.data.success) {
        this.$emit("snackbar", {
          text: "提交成功",
        });

        this.data = {};

        this.$refs.upload.reset();
      } else {
        console.log(res.data);
        this.$emit("snackbar", {
          text: res.data.message,
        });
      }
      this.loading = false;
      this.vaptcha = "";
      this.captcha = {};
      this.$refs.captcha.vaptcha.reset();
    },
    validate() {
      let c = this.handle_captcha(null, 1);
      if (c.captcha.token) {
        this.captcha = c.captcha;
        return true;
      }
      return false;
    },
    handle_captcha(obj = null, scene = 0) {
      let api_server;
      let token;
      if (obj === null) {
        if (this.vaptcha == null) {
          return null;
        }
        api_server = this.$refs.captcha.vaptcha.config.api_server;
        token = this.vaptcha.token;
      } else {
        api_server = obj.config.api_server;
        token = obj.token;
      }
      let api_server_array = api_server.split(".");
      if (api_server_array[1] !== "vaptcha") {
        return null;
      }
      return {
        captcha: {
          server:this.$refs.captcha.vaptcha.config.server,
          token: token,
          scene: scene,
        },
      };
    },
  },
};
</script>